import { z } from 'zod';

export const formZodSchema = z.object({
  firstName: z
    .string()
    .regex(/^[A-Za-z\s]+$/, 'First name must not contain numbers and/or special characters.')
    .min(1, 'First Name is required.'),
  contactName: z
    .string()
    .regex(/^[A-Za-z\s]+$/, 'Contact name must not contain numbers and/or special characters.')
    .min(1, 'Contact Name is required.'),
  lastName: z
    .string()
    .regex(/^[A-Za-z\s]+$/, 'Last name must not contain numbers and/or special characters.')
    .min(1, 'Last Name is required.'),
  company: z
    .string()
    .regex(/^[A-Za-z0-9\s]+$/, 'Company must not contain special characters.')
    .min(1, 'Company is required.'),
  email: z
    .string()
    .email('Invalid email address')
    .min(1, 'Email address is required.')
    .refine((val: string) => /\.[a-z]{2,}$/.test(val), {
      message: 'email must include a valid domain.',
    }),
  phone: z
    .string()
    .optional()
    .transform(val => val?.replace(/\s+/g, '').trim())
    .refine(val => !val || /^\d{10,11}$/.test(val), {
      message: 'Phone number must be 10-11 digits if provided and not contain letters.',
    }),
  county: z.string().regex(/^[A-Za-z\s]+$/, 'County must not contain numbers and/or special characters.'),
});

export type formData = z.infer<typeof formZodSchema>;
